import { AnchorProvider } from "@coral-xyz/anchor";
import { useConnection } from "@solana/wallet-adapter-react";
import { readOnlyAnchorWallet } from "@stepfinance/common";
import { DriftPositionFetcher } from "@stepfinance/dex";
import { useEffect, useMemo, useState } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useMarkets } from "../../contexts/market";
import { useRefreshContext } from "../../contexts/refresh";
import type { MarginAccount } from "../../types/margin";
import { getTokenByMint } from "../../utils/tokenInfo";

let timer;
export const useDriftProtocol = () => {
  const { publicKey, connected } = useEnrichedWallet();
  const { connection } = useConnection();
  const { marketsInitialised } = useMarkets();
  const { refreshID } = useRefreshContext();
  const [marginAccounts, setMarginAccounts] = useState<MarginAccount[]>([]);

  useEffect(() => {
    if (!connected) {
      setMarginAccounts([]);
    }
  }, [connected]);

  const fetcher = useMemo(() => {
    if (!publicKey) {
      return undefined;
    }
    const provider = new AnchorProvider(connection, readOnlyAnchorWallet, {
      commitment: "recent",
    });
    return new DriftPositionFetcher(publicKey, connection, provider.wallet, getTokenByMint);
  }, [connection, publicKey]);

  useEffect(() => {
    if (fetcher && marketsInitialised) {
      clearTimeout(timer);
      timer = setTimeout(
        () =>
          fetcher
            .fetchPositions()
            .then((result) => result && setMarginAccounts(result))
            .catch((error) => console.error("useDriftProtocol Error:", error)),
        300,
      );
    }
  }, [fetcher, marketsInitialised, refreshID]);

  return marginAccounts;
};
